import { StyleSheet } from 'react-native';

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  codeFieldRoot: {
    marginTop: 0,
    justifyContent: 'center',
  },
  codeInputText: loginColors => ({
    borderRadius: 6.2,
    color: loginColors.codeInputText,
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    height: 50,
    marginBottom: 30,
    marginTop: 20,
    marginHorizontal: 4,
    width: 50,
    borderWidth: 1,
    borderColor: Colors.smoothGrey,
    textAlign: 'center',
    textAlignVertical: 'center',
  }),
  codeInputIOSCursorAlignment: {
    paddingTop: 12.5,
  },
  codeInputIOSSymbolAlignment: {
    paddingTop: 15,
  },
});
